import React from "react";

import { useArrowLeft, useArrowRight } from "./hooks/useArrows";

function Arrow({
  disabled,
  onClick,
  className,
}: {
  disabled: boolean;
  onClick: VoidFunction;
  className: string;
}) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={className + (disabled ? " is-disabled" : "")}
    >
      <span className="slider-arrow-block" />
    </button>
  );
}

export function LeftArrow() {
  const { disabled, clickHandler } = useArrowLeft();

  return (
    <>
      <Arrow
        disabled={disabled}
        onClick={clickHandler}
        className="slider-arrow slider-arrow_back"
      />
    </>
  );
}

export function RightArrow() {
  const { disabled, clickHandler } = useArrowRight();

  return (
    <>
      <Arrow
        disabled={disabled}
        onClick={clickHandler}
        className="slider-arrow"
      />
    </>
  );
}
